/**
 * Client preference for background Collect&Go basket (winkelwagen) sync.
 * Persisted in localStorage; default OFF (opt-in — adds to the real cart).
 */

const KEY = 'cogo-basket-enabled'
const CHANGE_EVENT = 'cogo-basket-enabled-change'

/** Fallback when localStorage is unavailable (tests / SSR). */
let memoryEnabled: boolean | null = null

function readStored(): string | null {
  try {
    return localStorage.getItem(KEY)
  } catch {
    return memoryEnabled == null ? null : memoryEnabled ? '1' : '0'
  }
}

export function isCogoBasketEnabled(): boolean {
  const v = readStored()
  if (v == null) return false
  return v === '1' || v === 'true'
}

export function setCogoBasketEnabled(enabled: boolean): void {
  memoryEnabled = enabled
  try {
    localStorage.setItem(KEY, enabled ? '1' : '0')
  } catch {
    /* ignore quota / private mode — memory still updated */
  }
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(CHANGE_EVENT, { detail: enabled }))
  }
  // Enabling re-queues open orders: the basket worker calls /api/cogo/basket/reset
  // so each mapped product is reconsidered against current Menu quantities.
}

/** Same-tab + cross-tab updates. */
export function subscribeCogoBasketEnabled(
  cb: (enabled: boolean) => void
): () => void {
  if (typeof window === 'undefined') return () => {}
  const onStorage = (e: StorageEvent) => {
    if (e.key === KEY || e.key == null) cb(isCogoBasketEnabled())
  }
  const onCustom = (e: Event) => {
    const detail = (e as CustomEvent).detail
    cb(typeof detail === 'boolean' ? detail : isCogoBasketEnabled())
  }
  window.addEventListener('storage', onStorage)
  window.addEventListener(CHANGE_EVENT, onCustom)
  return () => {
    window.removeEventListener('storage', onStorage)
    window.removeEventListener(CHANGE_EVENT, onCustom)
  }
}
